import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const t = getToken();
        if (!t) {
            setUser(null);
            setLoading(false);
            return null;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            setToken(null);
            setUser(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setToken(data.token);
        await refresh();
        return data.user;
    };

    const register = async (email, password, full_name, opts = {}) => {
        const { data } = await api.post("/auth/register", {
            email, password, full_name,
            accept_terms: opts.accept_terms || false,
            accept_privacy: opts.accept_privacy || false,
            marketing_optin: opts.marketing_optin || false,
            invite_code: opts.invite_code || "",
        });
        setToken(data.token);
        await refresh();
        return data.user;
    };

    const logout = () => {
        setToken(null);
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
            {children}
        </AuthCtx.Provider>
    );
};

export const useAuth = () => useContext(AuthCtx);
